import React, { useState, useEffect } from "react"
import { getDettagliVeicoloAttivo } from "../../services/endpoints";
import { showProgress, moveFocusTo } from "../../utils/elements";
import {
  Container,
  Row,
  Col,
  Button
} from 'design-react-kit';

export const SibaMostraDettagliVeicolo = ({ veicolo, handleBack }) => {

  const [dettagliVeicolo, setDettagliVeicolo] = useState({});
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const responseDettagliVeicolo = await getDettagliVeicoloAttivo(veicolo.idVeicolo)
      console.log("responseDettagliVeicolo", responseDettagliVeicolo)
      if (responseDettagliVeicolo === undefined) {
        console.log('Veicolo con id %s non trovato', veicolo.idVeicolo)
        setLoading(false)
        return
      }
      setDettagliVeicolo(responseDettagliVeicolo)
      setLoading(false)
    }
    fetchData();
  }, []);

  useEffect(() => {
    moveFocusTo("chiudi_dettaglio");
  });

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="dettagli" tag="section">
      <Row>
        <Col>
          <h3>Dettagli veicolo</h3>
          <table className="table table-striped table-sm" id="vertical-1">
            <tbody>
              <tr>
                <th>Targa</th>
                <td>{veicolo.targa}</td>
              </tr>
              <tr>
                <th>Tipo</th>
                <td>{veicolo.tipoVeicolo}</td>
              </tr>
              <tr>
                <th>Categoria Euro</th>
                <td>{dettagliVeicolo.categoriaEuro}</td>
              </tr>
              <tr>
                <th>Cilindrata</th>
                <td>{dettagliVeicolo.cilindrata}</td>
              </tr>
              <tr>
                <th>Alimentazione</th>
                <td>{dettagliVeicolo.alimentazione}</td>
              </tr>
              <tr>
                <th>Data Immatricolazione</th>
                <td>{dettagliVeicolo.dataImmatricolazione}</td>
              </tr>
              <tr>
                <th>Data inizio propriet&agrave;</th>
                <td>{veicolo.dataInizioProprieta}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      <Button id="chiudi_dettaglio" className="btn btn-primary" size="xs" color="primary" icon={false} tag="button" onClick={handleBack} >
        Chiudi dettaglio
      </Button>
    </Container>
  )
}

export default SibaMostraDettagliVeicolo;